import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "./Slice/user-reducer"
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";

const persistConfig = {
  key: "user",
  storage,
  whitelist: [
    "userDetails",
    "token",
    "isAuthenticated",
    "theme",
    "permission"
  ],
};

const persistedUserReducer = persistReducer(persistConfig, userReducer);

const reducers = combineReducers({
  user: persistedUserReducer
});

const store = configureStore({
  reducer: reducers,
//   devTools: process.env.Envir !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }) // Ensure middleware is added correctly
});

const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export { persistor, store };
